var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63598",
    "data-name": "Group 63598",
    transform: "translate(-1527.5 -374.648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24443",
    "data-name": "Rectangle 24443",
    width: 66,
    height: 66,
    rx: 10,
    transform: "translate(1527.5 374.648)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shield_1_",
    "data-name": "shield (1)",
    d: "M3.87,1A1.407,1.407,0,0,0,2.55,2.234C1.455,10.9,1.922,17.955,4.416,24.166S11.4,35.652,18.083,40.836a1.407,1.407,0,0,0,1.725,0c6.689-5.186,11.109-10.49,13.563-16.706s2.915-13.262,1.964-21.876A1.407,1.407,0,0,0,33.213,1.2c-5.268,3.18-10.1,3.081-13.327.16a1.407,1.407,0,0,0-1.885,0C14.771,4.288,9.945,4.384,4.677,1.2A1.407,1.407,0,0,0,3.87,1ZM18.941,4.024c3.714,2.735,8.7,2.5,13.648.219.656,7.479.234,13.619-1.832,18.853-2.11,5.346-5.982,9.987-11.819,14.694C13.1,33.083,9.166,28.449,7.024,23.116c-2.1-5.225-2.513-11.36-1.742-18.879,4.953,2.288,9.939,2.521,13.659-.214Zm6.236,11.048a1.407,1.407,0,0,0-.965.428l-7.426,7.426L13.581,19.72a1.407,1.407,0,1,0-1.99,1.99l4.2,4.207a1.407,1.407,0,0,0,2,0L26.2,17.483a1.407,1.407,0,0,0-1.024-2.412Z",
    transform: "translate(1541.606 386.583)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersCard1);
export default __webpack_public_path__ + "static/media/users-card-1.3a6024f753652821e3fe91fad6972ead.svg";
export { ForwardRef as ReactComponent };